import { useEffect, useMemo } from 'react';
import { useRootMemoSelector } from 'use-redux-states';
import { useSocketListeners } from '../hooks';
import PeerCall from './PeerCall';

export default class PeerCallHooks {
  static useSocketListeners = () => useSocketListeners({ listeners: PeerCall.listeners });

  static useIsActive = () => {
    const callOtherUserId = useRootMemoSelector('call.otherUserId');
    const isIncoming = useRootMemoSelector('call.isIncoming');

    const active = useMemo(() => !!isIncoming || !!callOtherUserId, [isIncoming, callOtherUserId]);

    return { callOtherUserId, isIncoming, active };
  };

  static useConversationId = () => useRootMemoSelector('call.conversationId');

  static usePageUnload = () =>
    useEffect(() => {
      window.addEventListener('beforeunload', PeerCall.endCall);

      return () => {
        window.removeEventListener('beforeunload', PeerCall.endCall);
      };
    }, []);
}
